



















































import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/phonenumber';
import Component from 'vue-class-component';

@Component({
  components: {},
  directives: {}
})
export default class PhonenumberValidationDialog extends BaseComponent {
  maxWidth = 400;
  phoneNumber = null;
  code = null;

  dialogFlag = false;
  result = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  notification = {};
  title = '';
  content = '';

  mounted() {
    this.dialogFlag = true;
    setTimeout(() => {
      this.$refs['phoneNumber'].focus();
    }, 1000);
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }

  postpone() {
    this.loader.start('Processando...');
    service.phonenumberValidationPostpone().subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show("Confirmação adiada", 'success');
        this.closeForm();
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
        this.closeForm();
      }
    );
  }

  initValidation() {
    if (!this.phoneNumber || this.phoneNumber.length < 10) {
      return;
    }
    this.loader.start('Processando...');
    if (this.result) {
      this.result.msg = null;
    }
    service.initValidation(this.phoneNumber).subscribe(
      (res) => {
        this.loader.stop();
        this.result = res;
        if (res.solicitarCodigo) {
          this.code = null;
          setTimeout(() => {
            this.$refs['smsCode'].focus();            
          }, 500);
        }
        if (res.encerrar) {
          this.toast.show(res.msg, 'success');
          this.closeForm();
        }
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
        this.closeForm();
      }
    );
  }

  resetValidation() {
    this.result = null;
  }

  validCode() {
    if (!this.code || this.code.length < 6) {
      return;
    }

    this.result.msg = null;
    this.loader.start('Processando...');
    service.finishValidation(this.code).subscribe(res => {
      this.loader.stop();
      this.result = res;      
      if (res.solicitarCodigo) {
        this.code = null;
        setTimeout(() => {
          this.$refs['smsCode'].focus();            
        }, 500);
      }
      if (res.encerrar) {
        if (res.sucesso) {
          this.toast.show(res.msg, 'success');
        } else {
          this.toast.show(res.msg, 'warn');
        }
        this.closeForm();
      }
    }, error => {
      this.loader.stop();
      this.showToastApiError(error);
      this.closeForm();
    });
  }
}
